import { CommandAction } from "@/contexts/command-palette-context"
import type { SearchResult } from "@/schema/search"

const SEARCH_RESULT_GROUPS: { label: string; types: SearchResult["type"][] }[] = [
  { label: "Clients", types: ["client"] },
  { label: "Prospects", types: ["prospect"] },
  { label: "Past clients", types: ["past_client"] },
  { label: "Households", types: ["household"] },
  { label: "Contacts", types: ["contact"] },
  { label: "People", types: ["person"] },
  { label: "Businesses", types: ["business"] },
  { label: "Trusts", types: ["trust"] },
  { label: "Opportunities", types: ["opportunity"] },
  { label: "Users", types: ["user"] },
  { label: "Messages", types: ["sms_message"] },
  { label: "Custodian accounts", types: ["custodian_account"] },
  { label: "Financial accounts", types: ["financial_account"] },
  { label: "Insurance policies", types: ["insurance_policy"] },
]

export function groupSearchResults(results: SearchResult[]) {
  return SEARCH_RESULT_GROUPS.map(({ label, types }) => ({
    label,
    results: results.filter((result) => types.includes(result.type)),
  })).filter((group) => group.results.length > 0)
}

export function filterCommandActions(actions: CommandAction[], query: string): CommandAction[] {
  if (!query.trim()) return actions

  const normalized = query.toLowerCase()
  return actions.filter(
    (action) =>
      action.label.toLowerCase().includes(normalized) ||
      action.keywords.some((keyword) => keyword.toLowerCase().includes(normalized))
  )
}

export function resultKey(result: SearchResult): string {
  return `${result.type}::${result.id}`
}

export function getRecordTypeLabel(type: SearchResult["type"]): string {
  const labels: Record<SearchResult["type"], string> = {
    person: "Person",
    household: "Household",
    client: "Client",
    past_client: "Past client",
    prospect: "Prospect",
    contact: "Contact",
    opportunity: "Opportunity",
    sms_message: "Message",
    business: "Business",
    trust: "Trust",
    user: "User",
    custodian_account: "Custodian account",
    financial_account: "Account",
    insurance_policy: "Insurance policy",
  }
  return labels[type] || type
}

export function isEmail(query: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(query.trim())
}

export function isPhoneNumber(query: string): boolean {
  const phoneRegex = /^[\d\s\-\(\)\+]{10,}$/
  return phoneRegex.test(query.trim())
}

export function isName(query: string): boolean {
  const words = query.trim().split(/\s+/).filter(Boolean)
  return words.length >= 2 && words.every((word) => /^[a-zA-Z]+$/.test(word))
}
